// Рендер одного блока SEO-текста. Блоки описываются данными в market-режиме
// (`mode.seoContent`), а не версткой — так текст лежит рядом с остальными
// данными страницы и его видно целиком в одном месте.
//
// Поддерживаемые типы:
//   { type: 'h3',    text }                       — подзаголовок внутри секции
//   { type: 'p',     text }                       — абзац (text может быть JSX)
//   { type: 'ul',    items: [] }                  — маркированный список
//   { type: 'ol',    items: [] }                  — нумерованный список
//   { type: 'table', head: [], rows: [[]], note } — сравнительная таблица
//   { type: 'note',  title, text }                — врезка («что мы не делаем»)
//   { type: 'small', text }                       — сноска мелким шрифтом
//
// H2 задается полем `title` у секции (см. SeoContent.jsx), внутри блоков его нет:
// иерархия h2 → h3 не должна нарушаться.

export default function SeoContentBlock({ block }) {
  switch (block.type) {
    case "h3":
      return <h3 className="seo-content__h3">{block.text}</h3>;

    case "p":
      return <p className="seo-content__p">{block.text}</p>;

    case "ul":
      return (
        <ul className="seo-content__list">
          {block.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      );

    case "ol":
      return (
        <ol className="seo-content__list seo-content__list_ordered">
          {block.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      );

    case "table":
      return (
        <div className="seo-content__table-wrapper">
          <table className="seo-content__table">
            {block.head && (
              <thead>
                <tr>
                  {block.head.map((cell, i) => (
                    <th key={i}>{cell}</th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody>
              {block.rows.map((row, i) => (
                <tr key={i}>
                  {row.map((cell, j) => (
                    <td key={j}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );

    case "note":
      return (
        <div className="seo-content__note">
          {block.title && <p className="seo-content__note-title">{block.title}</p>}
          <p className="seo-content__note-text">{block.text}</p>
        </div>
      );

    case "small":
      return <p className="seo-content__small">{block.text}</p>;

    default:
      return null;
  }
}
